import React from 'react';
import { EmptyState as SdsEmptyState } from '@snapchat/snap-design-system';
import emptyImage from 'asset/empty.svg';

const EmptyState: React.FC<{ title: string; description?: string }> = ({ title, description }) => {
  return <SdsEmptyState title={title} description={description} imageUrl={emptyImage} />;
};

export default EmptyState;
